import { usePost, useDelete } from '../../../sharedModules/hooks/useQuery';

const URL = '/collections/department_group_memberships';

export function useAddGroupMembership() {
  return usePost();
}

export function addGroupMembershipVariables(userId: number, groupId: string, location: string) {
  return { url: URL, data: { user_id: userId, group_id: groupId, location } };
}

export function useRemoveGroupMembership() {
  return useDelete();
}

export function removeGroupMembershipVariables(membershipId: number) {
  return { url: `${URL}/${membershipId}` };
}
